import type { InputHTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

/* The search-bar field: full pill, hairline border, darkens on focus. */
export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        "flex h-10 w-full rounded-full border border-border bg-card px-4 py-1 text-sm transition-[border-color,box-shadow] placeholder:text-muted-foreground hover:border-input focus-visible:border-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}
